import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme, buttonStyles, spacing, typography, mergeStyles } from '../styles/theme';
import SimpleHeader from '../components/SimpleHeader';

export default function PaymentSuccess() {
  const navigate = useNavigate();

  // Optional: Refresh user data after payment
  useEffect(() => {
    // You could call an endpoint here to verify payment and update user status
    // For now, we'll just show the success message
  }, []);

  return (
    <>
      <SimpleHeader />
      <div style={{
        minHeight: '100vh',
        backgroundColor: theme.bg.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: spacing.xl
      }}>
        <div style={{
          maxWidth: '500px',
          width: '100%',
          backgroundColor: 'white',
          padding: spacing['4xl'],
          borderRadius: '12px',
          boxShadow: theme.shadow.large,
          textAlign: 'center'
        }}>
          {/* Success icon */}
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: theme.status.success,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            marginBottom: spacing.xl,
            fontSize: '40px'
          }}>
            ✓
          </div>

          <h1 style={{
            color: theme.text.primary,
            fontFamily: typography.fontFamily.primary,
            fontSize: typography.fontSize['3xl'],
            marginBottom: spacing.lg
          }}>
            Welcome to Premium!
          </h1>

          <p style={{
            color: theme.text.secondary,
            fontSize: typography.fontSize.base,
            lineHeight: typography.lineHeight.relaxed,
            marginBottom: spacing['2xl']
          }}>
            Your payment was successful. You now have access to:
          </p>

          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: `0 0 ${spacing['2xl']} 0`,
            color: theme.text.primary,
            textAlign: 'left'
          }}>
            <li style={{ marginBottom: spacing.md, paddingLeft: spacing.xl }}>
              ✓ Ad-free experience
            </li>
            <li style={{ marginBottom: spacing.md, paddingLeft: spacing.xl }}>
              ✓ GPT-4.1 mini for better, more accurate answers
            </li>
          </ul>

          <button
            onClick={() => navigate('/')}
            style={mergeStyles(
              buttonStyles.base,
              buttonStyles.primary,
              { width: '100%' }
            )}
          >
            Start Asking Questions
          </button>

          <p style={{
            marginTop: spacing.xl,
            fontSize: typography.fontSize.xs,
            color: theme.text.muted
          }}>
            A receipt has been sent to your email
          </p>
        </div>
      </div>
    </>
  );
}